    <div class="container" style="margin-top: 15px;">
         <div class="row">
              <div class="col-lg-12 header">
                <span>
                   <h1 class="text-dark">
                     <img src="./assets/img/logo.jpg" alt="Jane" width=100 />
                     2020 ELECTION
                    <small>Mizoram CSC-VLE Association</small>
                  </h1>
                </span>
              </div>
         </div>
    </div>
	<div class="container" style="margin-top: 15px;">
		<div class="row">
		  <div class="col-sm-12">
			<div class="card bg-light">
			  <div class="card-body leftbo">
			    <h5 class="card-title rbo">CSC Election 2020 Voter list</h5>
			    <table class="table">
			    	<thead>
			    		<tr>
			    			<th>#</th>
			    			<th>CSC (VLE & Location)</th>
			    			<th>CSC ID</th>
			    			<th>RD Block</th>
			    			<th>District</th>
			    			<th>Phone Number</th>
			    		</tr>
			    	</thead>
			    	<tbody>
			    		<tr *ngFor="let r of data; index as i">
			    			<td>{{i+1}}</td>
			    			<td>
						    	<span style="display: block;">{{r.fullName}}</span>
						    	<span style="display: block;">{{r.location}}</span>			    				
			    			</td>
			    			<td>{{r.cscid}}</td>
			    			<td>{{r.rdblock}}</td>
			    			<td>{{r.district}}</td>
			    			<td>{{r.phoneNumber}}</td>
			    		</tr>			    		
			    	</tbody>
			    </table>
			  </div>
			</div>
		  </div>
		</div>
	</div>
